import { motion } from "framer-motion";

// "Block reveal": a solid color panel wipes away (left → right) to uncover the
// content underneath as it scrolls into view. Great for image reveals.
export function BlockReveal({ children, className = "", panelColor = "#1D71B8", duration = 0.8, delay = 0.1 }) {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <motion.div
        initial={{ scale: 1.12 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: duration + 0.3, ease: [0.16, 1, 0.3, 1], delay }}
        className="h-full w-full"
      >
        {children}
      </motion.div>
      <motion.span
        initial={{ x: "0%" }}
        whileInView={{ x: "101%" }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration, ease: [0.77, 0, 0.18, 1], delay }}
        className="absolute inset-0 z-10"
        style={{ background: panelColor }}
      />
    </div>
  );
}

export default BlockReveal;
